import { Map } from 'immutable'

import config from '../../../../../../../../../config'

import { createFilterTableRegex, createTabsRegex } from '../../../../../../helpers'

const MODULE_KEY = config.modules.report.key
const BLOCK_KEY = config.modules.report.blocks.estates.key

export const localeSelector = (state) => state.getIn(['translate', 'locale'])

export const getAllRealEstatesIds = (state) =>
    state.getIn(['ui', 'modules', MODULE_KEY, 'workspace'], Map()).keySeq().toList()

export const getTabsIds = (state) => {
    const allTabsIds = state.get('tabs').keySeq().toList()
    const regex = createTabsRegex(MODULE_KEY, '.*', BLOCK_KEY)

    return allTabsIds.filter((tabId) => regex.test(tabId))
}

export const getFilterTableIds = (state) => {
    const allIds = state.getIn(['tables', 'filterTable']).keySeq().toList()
    const regex = createFilterTableRegex(MODULE_KEY, '.*', BLOCK_KEY)

    return allIds.filter((tableId) => regex.test(tableId))
}
